export default [
  {
    name: '安全生产',
    code: 'PE_SAFE_DAY',
    unit: '天',
    value: 0,
  },
  {
    name: '连续运行',
    code: 'PE_DCS1_LXYXTS',
    unit: '天',
    value: 0,
  },
  {
    name: '连续运行',
    code: 'PE_DCS2_LXYXTS',
    unit: '天',
    value: 0,
  },
  {
    name: '实时负荷',
    code: 'DCS1.MW',
    unit: 'MW',
    value: '-',
  },
  {
    name: '实时负荷',
    code: 'DCS2.MW',
    unit: 'MW',
    value: '-',
  },
  {
    name: '日电量',
    code: 'PE_ALL_FDL_DAY',
    unit: '万kwh',
    value: '-',
  },
  {
    name: '月电量',
    code: 'PE_FDL_MON_ALL',
    unit: '万kwh',
    value: '-',
  },
  {
    name: '年电量',
    code: 'PE_FDL_YEAR_ALL',
    unit: '万kwh',
    value: '-',
  },
  {
    name: '日供热',
    code: 'PE.QCGRLLYLL.D',
    unit: 'GJ',
    value: '-',
  },
  {
    name: '月供热',
    code: 'PE.QCGRLLYLL.M',
    unit: 'GJ',
    value: '-',
  },
  {
    name: '年供热',
    code: 'PE.QCGRLLYLL.Y',
    unit: 'GJ',
    value: '-',
  },
  {
    name: '脱硝效率',
    code: 'PE_1_TXXL_AVG_DAY',
    unit: '%',
    value: '-',
  },
  {
    name: '脱硝效率',
    code: 'PE_2_TXXL_AVG_DAY',
    unit: '%',
    value: '-',
  },
  {
    name: '脱硫效率',
    code: 'TL.DPU1SPA55',
    unit: '%',
    value: '-',
  },
  {
    name: '脱硫效率',
    code: 'TL.2HTD1FU151',
    unit: '%',
    value: '-',
  },
  {
    name: '烟囱烟尘',
    code: 'TL.JTA10CQ104',
    unit: 'mg/Nm³',
    value: '-',
  },
  {
    name: '排放标准',
    code: '',
    unit: 'mg/Nm³',
    value: '5.00',
  },
  {
    name: '烟囱SO2',
    code: 'TL.JTA10CQ101',
    unit: 'mg/Nm³',
    value: '-',
  },
  {
    name: '排放标准',
    code: '',
    unit: 'mg/Nm³',
    value: '35.00',
  },
  {
    name: '烟囱NOX',
    code: 'TL.JTA10CQ103',
    unit: 'mg/Nm³',
    value: '-',
  },
  {
    name: '排放标准',
    code: '',
    unit: 'mg/Nm³',
    value: '50.00',
  },
]
